import ExcerptionsPage from './excerptions-page'

export default ExcerptionsPage
